// React Query обвивките за черновите на складовите документи. Списъкът се
// опреснява на 30 s (статусът „Редактира се" на колегите); до BE без
// черновите (404) списъкът е празен и екранът работи с локалната чернова.
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { deleteDraft, listDrafts, takeOverDraft, type DraftType } from "../api/inventoryDrafts";
import { useIsEdgeLocal } from "./useEdgeMode";

export const useDrafts = (type: DraftType, enabled = true) => {
  const isLocal = useIsEdgeLocal();
  return useQuery({
    queryKey: ["inventory", "drafts", type],
    queryFn: () => listDrafts(type),
    enabled: enabled && !isLocal,
    retry: false,
    refetchInterval: 30_000,
  });
};

export const useDeleteDraft = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => deleteDraft(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["inventory", "drafts"] });
      qc.invalidateQueries({ queryKey: ["inventory", "nav-counts"] });
    },
  });
};

export const useTakeOverDraft = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => takeOverDraft(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["inventory", "drafts"] }),
  });
};
